export default __webpack_public_path__ + "images/icons/map-mark-4ce6acbfdddaa6d0780cc42c862ebc2c.svg";